import React, { PureComponent } from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import SurveyItem from '../../util/SurveyItem';
import { SurveyItemComponent } from '../SurveyItem';
import { Text } from '@lifeomic/chroma-react/components/Text';
import withCheckForEnablement, {
  WithCheckForEnablementInjectedProps,
} from '../hoc/withCheckForEnablement';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginTop: theme.spacing(6),
    },
    subItemRoot: {
      width: '100%',
      margin: theme.spacing(2),
    },
  });

export interface GroupOwnProps {
  surveyItem: SurveyItem;
}

export type GroupProps = WithStyles<typeof styles> &
  WithCheckForEnablementInjectedProps &
  GroupOwnProps;

class Group extends PureComponent<GroupProps> {
  getHeaderText = () => {
    const {
      surveyItem: { prefix, text },
    } = this.props;

    let headerText = '';
    if (prefix) {
      headerText = `(${prefix}) ${text}`;
    } else {
      headerText = text || '';
    }

    if (!headerText) return null;

    return <Text size="headline">{headerText}</Text>;
  };

  render() {
    const { surveyItem, classes, isEnabled } = this.props;

    if (!isEnabled) return null;

    return (
      <div className={classes.root}>
        {this.getHeaderText()}
        <div className={classes.subItemRoot}>
          {(surveyItem.subItems || [])
            .filter(Boolean)
            .map((subItem: SurveyItem) => (
              <SurveyItemComponent key={subItem.link} surveyItem={subItem} />
            ))}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withCheckForEnablement(Group));
